import 'regenerator-runtime';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './sentry';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { RecoilRoot } from 'recoil';
import { YourGPT } from "@yourgpt/widget-web-sdk/react";

import store from 'store';

import App from './App';
import { APP_ROOT_ID } from 'utils/constants';
import './i18n';

const queryClient = new QueryClient();

const YOURGPT_WIDGET_ID = import.meta.env.VITE_YOURGPT_WIDGET_ID;
if (YOURGPT_WIDGET_ID) {
  YourGPT.init({
    widgetId: YOURGPT_WIDGET_ID,
    endpoint: 'https://widget.yourgpt.ai',
  }).then(() => {
    console.log('[YourGPT] Widget initialized successfully');

    // Hide the default launcher button and add margins for Android navigation
    const style = document.createElement('style');
    style.textContent = `
      /* Hide the default YourGPT launcher button */
      .ygpts-widgetBtn {
        display: none !important;
      }

      /* Add margins for Android navigation (top and bottom) */
      [class*="ygpt-chatbot"],
      [class*="ygpts-frame"] {
        margin-top: 24px !important;
        margin-bottom: 24px !important;
        max-height: calc(100vh - 48px) !important;
      }
    `;
    document.head.appendChild(style);
    console.log('[YourGPT] Applied custom styles');
  }).catch((error) => {
    console.error('[YourGPT] Initialization failed:', error);
  });
}

ReactDOM.createRoot(document.getElementById(APP_ROOT_ID) as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <RecoilRoot>
          <App />
      </RecoilRoot>
    </Provider>
  </QueryClientProvider>
);
